export const mapBookingTasks = (tasks, steps) => {
    if (!(tasks === null || tasks === void 0 ? void 0 : tasks.length) || !(steps === null || steps === void 0 ? void 0 : steps.length)) {
        return [];
    }
    return steps.map((step) => ({
        step,
        records: tasks.filter((task) => task.bookingStepTemplateId === step.id),
    }));
};
